import { render, staticRenderFns } from "./ricercaPerCodFAO.vue?vue&type=template&id=75d4f09f&"
import script from "./ricercaPerCodFAO.vue?vue&type=script&lang=js&"
export * from "./ricercaPerCodFAO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports